// 11位时间戳时间戳转年/月/日/十/分/秒
function formateDate(timestamp) {
    let time = new Date(parseInt(timestamp));
    let year = time.getFullYear(),
        month = time.getMonth() + 1,
        date = time.getDate(),
        h = time.getHours(),
        min = time.getMinutes(),
        s = time.getSeconds();
    return { year, month, date, h, min, s }
}
// axios返回数据格式化
function formatAxiosRes(res) {
    if (!res.code) {
        return res.data;
    }
    return res;
}
// 万 格式化
function formateEncourageCount(num) {
    let length = num.toString().length;
    if (length >= 6) {
        return `${Math.floor(num / 10000 * 100) / 100}万`
    } else {
        return num;
    }
}

// 千分位 格式化
function foramteVoteCount(num) {
    num = num.toString();
    let ret = Array.from(num).reverse().reduce((result = [], currentValue, currentIndex, arr) => {
        if ((currentIndex + 1) % 3 === 0 && (currentIndex + 1) !== arr.length) {
            result.push(currentValue, ',')
            return result;
        }
        result.push(currentValue);
        return result;
    }, [])
    return ret.reverse().join('');
}


export { formatAxiosRes, formateDate, formateEncourageCount, foramteVoteCount }


// WEBPACK FOOTER //
// ./src/pages/act/202010/unit_member/js/formate.js